import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { advancedFilter } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

import AdvancedFilter from 'ui/pages/AdvancedFilter';

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/advanced-filter">
      <AdvancedFilter/>
    </PageNextJs>
  );
};

export default Page;

// export { advancedFilter as getServerSideProps } from 'nextjs/getServerSideProps';

export const getServerSideProps = async(context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [ 'common' ])),
      ...(await advancedFilter(context)),
    },
  };
};
